import * as React from "react"

export { LineJoin, LineCap } from "./types/Stroke"
export { collectFiltersFromProps } from "./utils/filtersForNode"
export {
    getConfigFromPreviewURL as getConfigFromURL,
    getConfigFromPreviewURL,
    getConfigFromVekterURL,
} from "./utils/getConfigFromURL"
export { serverURL } from "./utils/serverURL"
export { memoize } from "../utils/memoize"
export { InternalID } from "../utils/internalId"
export { LinearGradientElementProperties } from "./utils/elementPropertiesForGradient"
export { frameFromElement, frameFromElements, dispatchKeyDownEvent, DOM } from "./utils/dom"
export { FillProperties } from "./traits/Fill"
export { FilterProperties, FilterNumberProperties } from "./traits/Filters"
export { BackgroundFilterProperties } from "./traits/BackdropFilters"
export { RadiusProperties } from "./traits/Radius"
export { BlendingProperties, BlendingMode, collectBlendingFromProps } from "./traits/Blending"
export { Background, BackgroundProperties } from "./traits/Background"
export { ImageFit, BackgroundImage } from "./types/BackgroundImage"
export { WithOpacity, withOpacity, collectOpacityFromProps } from "./traits/Opacity"
export { DeprecatedVisualProperties, collectVisualStyleFromProps } from "./style/collectVisualStyleFromProps"
export { WithShape, withShape } from "./traits/Shape"
export { BoxShadowProperties } from "./traits/BoxShadow"
export { gradientForShape } from "./utils/gradientForShape"
export { debounce } from "./utils/debounce"
export { throttle } from "./utils/throttle"
export { setImageForFill, imageUrlForFill, imageUrlForAsset, QualityOptions } from "./utils/imageForFill"
export { _imageURL, _imageScalingMethod } from "./utils/imageForFill" // for testing
export { imagePatternPropsForFill } from "./utils/imagePatternPropsForFill"
export {
    ComponentDefinition,
    ComponentIdentifier,
    ComponentLoader,
    ComponentMap,
    DesignComponentDefinition,
    PackageIdentifier,
    TokenDefinition,
    TokenMap,
    componentLoader,
    isDesignDefinition,
    isErrorDefinition,
    isOverride,
    isReactDefinition,
    updateComponentLoader,
    updateComponentLoaderWithScript,
} from "./componentLoader"
export { findMasters } from "./componentLoader/masters"
export { localPackageFallbackIdentifier } from "./componentLoader/package"
export {
    ControlDescription,
    CompactControlsDescription,
    BooleanControlDescription,
    NumberControlDescription,
    StringControlDescription,
    FusedNumberControlDescription,
    EnumControlDescription,
    SegmentedEnumControlDescription,
    ColorControlDescription,
    ImageControlDescription,
    FileControlDescription,
    ComponentInstanceDescription,
    ArrayControlDescription,
    ControlType,
    PropertyControls,
} from "./types/PropertyControls"
export { WithFractionOfFreeSpace } from "./traits/FreeSpace"
export { withStylable } from "./traits/Stylable"
export { isOfAnnotatedType, annotateTypeOnStringify } from "./utils/annotateTypeOnStringify"
export { PathSegment } from "./types/PathSegment"
export { PathSegments } from "./types/PathSegments"
export { WithPath, withPath, WithPaths, isStraightCurve, pathDefaults, toSVGPath } from "./traits/Path"
export { BoxShadow, Shadow } from "./types/Shadow"
export { StrokeAlignment } from "./types/StrokeAlignment"
export { Rect } from "./types/Rect"
export { Size } from "./types/Size"
export { Line } from "./types/Line"
export { Point } from "./types/Point"
export { Gradient, LinearGradient, LinearGradientBase, RadialGradient, RadialGradientBase } from "./types/Gradient"
export {
    Frame,
    FrameWithMotion,
    FrameProps,
    DeprecatedFrame,
    DeprecatedFrameProperties,
    DeprecatedFrameWithEvents,
    DeprecatedFrameWithEventsProps,
    FrameLayoutProperties,
    DeprecatedCoreFrameProps,
    BaseFrameProps,
    CSSTransformProperties,
    VisualProperties,
} from "./presentation/Frame"
export { Layer, LayerProps, IdentityProps } from "./presentation/Layer"
export { SVG, SVGProperties } from "./presentation/SVG"
export { Text, TextProperties, TextAlignment } from "./presentation/Text"
export { Vector, VectorProperties } from "./presentation/Vector"
export { VectorGroup, VectorGroupProperties } from "./presentation/VectorGroup"
export { ComponentContainer, ComponentContainerProperties } from "./presentation/ComponentContainer"
export { TextBlock, draftBlockRendererFunction } from "./presentation/TextBlock"
export { TransformValues } from "./types/TransformValues"
export {
    DefaultProps,
    ConstraintMask,
    ConstraintValues,
    ConstraintProperties,
    ConstraintPercentage,
    DimensionType,
    valueToDimensionType,
} from "./types/Constraints"

export {
    ProvideParentSize,
    NewConstraintProperties,
    calculateRect,
    ParentSizeState,
    constraintsEnabled,
} from "./types/NewConstraints"
export { Color, ConvertColor, ColorMixOptions } from "./types/Color"
export {
    ColorFormat,
    ColorRGBA,
    ColorHSLA,
    ColorHSL,
    ColorHSVA,
    ColorMixModelType,
    IncomingColor,
} from "./types/Color/types"
export { BorderStyle, BorderProperties } from "./style/BorderComponent"
export { draftStyleFunction, draftStyles, getStyleForTypefaceOrSelector } from "./style/draft"
export { isEqual } from "./utils/isEqual"
export { isFiniteNumber, finiteNumber } from "./utils/isFiniteNumber"
export { isShallowEqualArray } from "./utils/isShallowEqualArray"
export { roundedNumber, roundedNumberString, roundWithOffset } from "./utils/roundedNumber"
export { transformString } from "./utils/transformString"
export { localShadowFrame, shadowForShape } from "./style/shadow"
export {
    PresentationTree,
    renderPresentationTree,
    convertPresentationTree,
    addServerUrlToResourceProps,
} from "./presentation/PresentationTree"
export { RenderTarget, executeInRenderEnvironment, setGlobalRenderEnvironment } from "./types/RenderEnvironment"
export {
    NavigateTo,
    NavigationLink,
    NavigationTarget,
    NavigationTransition,
    NavigationTransitionDirection,
} from "./types/NavigationLink"

export { WithChildInsertion, withChildInsertion } from "./traits/ChildInsertion"
export { ChildLayoutProvider, providesChildLayout } from "./traits/ChildLayoutProvider"
export { FreeSpaceProvider, providesFreeSpace, toFreeSpace } from "./traits/FreeSpaceProvider"
export { AutoSize, hasAutoSize, toAutoSize } from "./traits/AutoSize"
export { WithCSSExport, withCSSExport } from "./traits/CSSExport"
export { toPaddingSize } from "./traits/PaddingSize"

import * as f from "./config/fonts"
export const fonts = f

import { collectBorderStyleForProps } from "./style/BorderComponent"
export const styles = {
    collectBorder: collectBorderStyleForProps,
}
export { createDesignComponent, CanvasStore, PropertyTree } from "./DesignComponentWrapper"

export { CustomProperties, CustomPropertiesContext } from "./presentation/CustomProperties"
